import dayjs from 'dayjs';
import { CERTIFICATE_CATEGORIES } from 'Constants/CertificateNames';

// Shared cell formatting for the three certificate tables and the verify tool,
// so a null column reads the same way everywhere.

const EMPTY = '---';

/**
 * Category names live in i18n under admin.certificateNames.categories.*. A
 * value the backend adds later would have no key yet, so it falls back to the
 * raw value rather than printing a missing i18n key at the user.
 */
export const formatCertificateCategory = (t, category) => {
    if (!category) {
        return t('admin.certificateNames.noCategory');
    }

    return CERTIFICATE_CATEGORIES.includes(category)
        ? t(`admin.certificateNames.categories.${category}`)
        : category;
};

/** The API sends ISO 8601 with an offset, which dayjs parses natively. */
export const formatDate = (value) => (value ? dayjs(value).format('YYYY-MM-DD') : EMPTY);

export const formatDateTime = (value) => (value ? dayjs(value).format('YYYY-MM-DD HH:mm') : EMPTY);

/**
 * The backend computes the similarity (two decimals, 0..100) — this only adds
 * the percent sign. Zero is a real score, so only null/undefined is empty.
 */
export const formatSimilarity = (value) =>
    value === null || value === undefined ? EMPTY : `${value}%`;

/**
 * The most specific message an API error carries: the first field error if
 * there is one (a 422 about the file says what is wrong with the file), else
 * the response message, else the fallback.
 */
export const apiErrorMessage = (error, fallback) => {
    const errors = error?.response?.data?.errors;
    const first = errors ? Object.values(errors).flat()[0] : null;

    return first || error?.response?.data?.message || fallback;
};

/** Laravel's 422 body as { field: 'first message' }. */
export const fieldErrors = (error) => {
    const errors = error?.response?.status === 422 ? error?.response?.data?.errors ?? {} : {};

    return Object.keys(errors).reduce((all, key) => ({ ...all, [key]: [].concat(errors[key])[0] }), {});
};

export const formatText =(value) => (value === null || value === undefined || value === '' ? EMPTY : value);
